import { Components, Theme } from '@mui/material';

export default {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.neutral.containerLow
    }),
    fallback: ({ theme }) => ({
      color: theme.palette.neutral.onSurfaceVariant,
    }),
  }
} as Components<Theme>['MuiAvatar'];